import React from 'react';
import {Box, LinearProgress, Stack, StackProps, SxProps, Tooltip, Typography} from "@mui/material"
import {TimeUtil} from "../../library/TimeUtil"
import {AnyCustomModelJson} from "../../api/json/CustomModelJson"
import {resolveFinetuneStatus} from "../../api/json/CustomModelStatus"

interface CustomModelStatusInfoProps {
    customModel: AnyCustomModelJson
    horizontalLayout?: boolean
    showTime?: boolean
    sx?: SxProps
}

function CustomModelStatusInfo({customModel, horizontalLayout, showTime, sx}: CustomModelStatusInfoProps) {
    const {label, muiColor, time, percentProgress} = resolveFinetuneStatus(customModel)

    const stackProps: StackProps = horizontalLayout
        ? {direction: "row", spacing: 1.5, alignItems: "center"}
        : {direction: "column", spacing: 0.5, alignItems: "flex-start", justifyContent: "center"}

    return (
        <Stack {...stackProps} sx={sx} component="span">
            {percentProgress !== undefined && percentProgress > 0 ?
                <LinearProgress variant="determinate" value={percentProgress ?? 50} sx={{width: 80}}/>
                :
                <Tooltip title={customModel.failedReason ?? ""}>
                    <Stack direction="row" spacing={0.75} alignItems="center" component="span">
                        <Box component="span" sx={{width: 8, height: 8, borderRadius: "50%", bgcolor: `${muiColor}.main`}}/>
                        <Typography variant="body2" component="span">{label}</Typography>
                    </Stack>
                </Tooltip>
            }
            {showTime && <Typography variant="caption" component="span">{TimeUtil.ago(time)}</Typography>}
        </Stack>
    );
}

export default CustomModelStatusInfo;
